$(document).ready(function() {
  $('.open_new_tab').attr('target','_blank');
});
